import JwtExpiredError from '../errors/JwtExpiredError';
import JwtParseError from '../errors/JwtParseError';
import { logout } from './logIn';

export interface JWTPayload {
  exp: number; // 만료일시
}

/**
 * JWT Decoder
 */
export const decodePayloadFromJWT = <T = unknown>(token: string): T => {
  try {
    const base64Payload = token.split(`.`)[1];
    const payload = Buffer.from(base64Payload, `base64`);
    return JSON.parse(payload.toString()) || null;
  } catch (e) {
    throw new JwtParseError(token);
  }
};

/**
 * JWT Validator
 */
export const validateJWT = (token: string, throwError?: boolean): boolean => {
  try {
    const payload = decodePayloadFromJWT<JWTPayload>(token);
    // 토큰 만료 확인
    if (payload.exp * 1000 < new Date().getTime()) {
      logout();
      throw new JwtExpiredError();
    }
    return true;
  } catch (e) {
    if (throwError) {
      throw e;
    }
  }
  return false;
};
